import axios from "axios";
import authentication from "@/authentication";
import { cacheAdapterEnhancer } from "axios-extensions";
import LRUCache from "lru-cache";

const httpCache = axios.create({
  headers: { "Cache-Control": "no-cache" },
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, {
    defaultCache: new LRUCache({ maxAge: 20 * 60 * 1000, max: 100 })
  })
});

export default {
  baseUrl: process.env.VUE_APP_API_DELIVERABILITY_SERVICE_BASE,
  async loadAlertTypes() {
    await authentication.isAuthenticated();
    const response = await httpCache.get(`${this.baseUrl}/GetAlertTypes`, {
      headers: { Authorization: "Bearer " + authentication.getToken() }
    });
    return response.data;
  },
  async loadMapData(disableCache) {
    await authentication.isAuthenticated();
    var api = httpCache;
    if (disableCache) api = axios;
    const response = await api.get(`${this.baseUrl}/GetAlertsForecast`, {
      headers: { Authorization: "Bearer " + authentication.getToken() }
    });
    if (typeof response.data === "string") return JSON.parse(response.data);
    else return response.data;
  },
  async loadMapOverlayFiles() {
    await authentication.isAuthenticated();
    const response = await httpCache.get(`${this.baseUrl}/GetMapOverlayFiles`, {
      headers: { Authorization: "Bearer " + authentication.getToken() }
    });
    if (typeof response.data === "string") return JSON.parse(response.data);
    else return response.data;
  },
  async loadOverlayFile(fileName) {
    await authentication.isAuthenticated();
    const response = await httpCache.get(
      `${this.baseUrl}/GetOverlayFile?fileName=${fileName}`,
      {
        headers: { Authorization: "Bearer " + authentication.getToken() }
      }
    );
    if (typeof response.data === "string") return JSON.parse(response.data);
    else return response.data;
  },
  async getHurricaneStormData(atcfId) {
    await authentication.isAuthenticated();
    const response = await httpCache.get(
      `${this.baseUrl}/GetHurricaneStormData?atcfId=${atcfId}`,
      {
        headers: { Authorization: "Bearer " + authentication.getToken() }
      }
    );
    if (typeof response.data === "string") return JSON.parse(response.data);
    else return response.data;
  },
  async getHurricaneStormTrackData(atcfId) {
    await authentication.isAuthenticated();
    const response = await httpCache.get(
      `${this.baseUrl}/GetHurricaneStormTrackData?atcfId=${atcfId}`,
      {
        headers: { Authorization: "Bearer " + authentication.getToken() }
      }
    );
    if (typeof response.data === "string") return JSON.parse(response.data);
    else return response.data;
  },
  async getHurricaneStormList() {
    await authentication.isAuthenticated();
    const response = await httpCache.get(
      `${this.baseUrl}/GetHurricaneStormList`,
      {
        headers: { Authorization: "Bearer " + authentication.getToken() }
      }
    );
    if (typeof response.data === "string") return JSON.parse(response.data);
    else return response.data;
  }
};
